import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import {Button, ButtonGroup, Spinner} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";
import DeviceGroupScheduleForm from "../_forms/DeviceGroupScheduleForm";
import {deviceGroupScheduleAction} from "../../../../actions/device-group-schedule.actions";
import {claimTypes} from "../../../../constants/claim.constants";

const DeviceGroupScheduleTable = ({list, t, user, showModal, hideModal, editScheduleDay}) => {

    const scheduleCrudPermission = user[`c_schedule.actions.crud`] || null;

    const onEditModal = (row) => {
        const modalProps = {
            open: true,
            title: t('edit-schedule'),
            component: <DeviceGroupScheduleForm submit={onSubmitEdit} data={row} />,
            submitBtn: {
                className: 'btn btn-primary',
                label: 'save-changes'
            }
        };
        showModal(modalProps, 'formModal');
    };

    const onSubmitEdit = (data, errorValidation) => {
        editScheduleDay(data, (error) => {
            errorValidation(error)
        });
    };

    const columns = [
        {
            Header: 'name',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    t(data.name.toLowerCase())
                );
            }
        },
        {
            Header: 'start',
            accessor: 'start'
        },
        {
            Header: 'end',
            accessor: 'end'
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            show: scheduleCrudPermission === claimTypes.READ_WRITE,
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <ButtonGroup size={'sm'}>
                        <Button variant={"primary"} onClick={() => onEditModal(data)}>
                            <i className="fas fa-edit" />
                        </Button>
                    </ButtonGroup>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('schedule-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            )
            : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            {tableResult}
        </div>
    )
};

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    },
    editScheduleDay: (scheduleDayModal, errorHandler) => {
        dispatch(deviceGroupScheduleAction.editScheduleDay(scheduleDayModal, errorHandler))
    }
});
export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(DeviceGroupScheduleTable));
